import { z } from "zod/v4";

import { OfferDtoSchema } from "../../../dtos/offers";

export const GetOffersResponseBodySchema = z.object({
  offers: OfferDtoSchema.array(),
});

export type GetOffersResponseBodyType = z.infer<
  typeof GetOffersResponseBodySchema
>;
